import { request } from '../index'

export function filter(params={}){
    return request({url: "nfce/", params})
}


// WEBPACK FOOTER //
// ./src/api/nfce/index.js